if (!customElements.get('cart-progress-bar')) {
  class CartProgressBar extends HTMLElement {
    connectedCallback() {
      this.fillEl = this.querySelector('[data-cart-progress-fill]');
      this.textEl = this.querySelector('[data-cart-progress-text]');
      this.icons = this.querySelectorAll('.track-icon');
      this.milestones = [1000, 2000, 4000];

      const currentTotal = parseInt(this.dataset.currentTotal, 10) || 0;
      const currentSubtotal = currentTotal / 100;

      // window par store karo taaki drawer re-render hone par bhi pichli value yaad rahe
      const prevSubtotal = window.__cartProgressPrev;
      window.__cartProgressPrev = currentSubtotal;

      const isFirstLoad = typeof prevSubtotal === 'undefined';
      const itemWasAdded = !isFirstLoad && currentSubtotal > prevSubtotal;
      const nextMilestone = this.getNextMilestone(currentSubtotal);

      if (itemWasAdded && nextMilestone !== null) {
        this.peekThenSettle(currentSubtotal, nextMilestone);
      } else {
        this.update(currentSubtotal);
      }
    }

    getNextMilestone(subtotal) {
      return this.milestones.find((m) => subtotal < m) || null;
    }

    percentFor(subtotal) {
      if (subtotal <= 1000) return (subtotal / 1000) * 15;
      if (subtotal <= 2000) return 15 + ((subtotal - 1000) / 1000) * 35;
      if (subtotal <= 4000) return 50 + ((subtotal - 2000) / 2000) * 35;
      return 100;
    }

    peekThenSettle(actualSubtotal, milestoneValue) {
      const peekPercent = this.percentFor(milestoneValue);
      const actualPercent = this.percentFor(actualSubtotal);
      const milestoneIcon = [...this.icons].find(
        (icon) => parseInt(icon.dataset.milestone, 10) === milestoneValue
      );

      // Text/icons ka lock-unlock state abhi actual value ke hisab se set kar do
      // (fill sirf peek ke liye alag se animate karenge)
      this.updateIconsAndText(actualSubtotal);

      // Step 1: bar ko turant milestone tak udhaa do (pulsing band karke, taaki clash na ho)
      if (this.fillEl) {
        this.fillEl.classList.remove('progress-bar-fill--pulsing');
        this.fillEl.style.width = peekPercent + '%';
      }
      if (milestoneIcon) milestoneIcon.classList.add('track-icon--peek');

      // Step 2: thodi der ruko, fir wapas actual position par le aao aur continuous
      // pulse animation shuru kar do (jab tak agla milestone unlock na ho)
      setTimeout(() => {
        if (this.fillEl) this.fillEl.style.width = actualPercent + '%';
        if (milestoneIcon) milestoneIcon.classList.remove('track-icon--peek');
        this.startPulse(actualSubtotal);
      }, 700);
    }

    updateIconsAndText(subtotal) {
      const nextMilestone = this.getNextMilestone(subtotal);

      this.icons.forEach((icon) => {
        const milestone = parseInt(icon.dataset.milestone, 10);
        const isUnlocked = subtotal >= milestone;
        icon.classList.toggle('track-icon--unlocked', isUnlocked);
        icon.classList.toggle('track-icon--next', !isUnlocked && milestone === nextMilestone);
      });

      if (!this.textEl) return;

      if (subtotal < 1000) {
        const rem = 1000 - subtotal;
        this.textEl.innerHTML = `Add <strong>₹${rem.toLocaleString('en-IN')}</strong> more to unlock <strong>Free shipping</strong>`;
      } else if (subtotal < 2000) {
        const rem = 2000 - subtotal;
        this.textEl.innerHTML = `Add <strong>₹${rem.toLocaleString('en-IN')}</strong> more to unlock <strong>Save ₹500</strong>`;
      } else if (subtotal < 4000) {
        const rem = 4000 - subtotal;
        this.textEl.innerHTML = `Add <strong>₹${rem.toLocaleString('en-IN')}</strong> more to unlock <strong>Save ₹1,000</strong>`;
      } else {
        this.textEl.innerHTML = `You've unlocked <strong>maximum savings ₹1,000</strong>`;
      }
    }

    // Fill ko actual value aur agle milestone ke beech continuously
    // (jaaye - wapas aaye - jaaye - wapas aaye...) pulse karwata hai.
    startPulse(subtotal) {
      if (!this.fillEl) return;
      const nextMilestone = this.getNextMilestone(subtotal);

      if (nextMilestone === null) {
        // Sab milestones unlock ho chuke — pulse band, bar 100% par settle
        this.fillEl.classList.remove('progress-bar-fill--pulsing');
        this.fillEl.style.width = this.percentFor(subtotal) + '%';
        return;
      }

      const actualPercent = this.percentFor(subtotal);
      const milestonePercent = this.percentFor(nextMilestone);

      this.fillEl.style.setProperty('--fill-actual', actualPercent + '%');
      this.fillEl.style.setProperty('--fill-milestone', milestonePercent + '%');
      this.fillEl.style.width = '';
      this.fillEl.classList.add('progress-bar-fill--pulsing');
    }

    update(subtotal) {
      this.updateIconsAndText(subtotal);
      this.startPulse(subtotal);
    }
  }

  customElements.define('cart-progress-bar', CartProgressBar);
}
